import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService, UserPermissions } from '../../services/auth.service';
import { User } from '../../models/user.model';

@Component({
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-forms.scss'],
  providers: [AuthService]
})
export class LoginFormComponent implements OnInit {
  public userPermissions: UserPermissions;
  loginForm: FormGroup;
  errorMessage: string;
  private redirectTo;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.createLoginForm();
    this.route.queryParams.subscribe(params => {
        this.redirectTo = params['redirectTo'];
    });
  }

  ngOnInit() {
    this.authService.permissions$.subscribe(permissions => {
      this.userPermissions = permissions;
    });
  }

  createLoginForm() {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.required],
      stayLoggedIn: []
    });
  }

  get email() {
    return this.loginForm.get('email');
  }

  async login() {
    this.errorMessage = null;

    try {
      const user = new User(
        this.loginForm.value.email,
        this.loginForm.value.password
      );
      const authToken = await this.authService.login(user);
      if (!authToken) {
        throw new Error('Unknown error');
      }

      if (this.loginForm.value.stayLoggedIn) {
        localStorage.setItem('Authorization', authToken);
      } else {
        sessionStorage.setItem('Authorization', authToken);
      }

      const startingRoute = await this.authService.getStartingRoute();
      this.router.navigate([startingRoute], { queryParams: { redirectTo: this.redirectTo }});
    } catch (err) {
      console.log('err:', err)
      if (err.code === 401) {
        this.errorMessage = 'Invalid email or password';
      } else if (err.message === 'connect ETIMEDOUT') {
        this.errorMessage = 'Unable to connect to database. Please contact your system administrator';
      } else if (err.message === '{\"isTrusted\":true}') {
        this.errorMessage = 'Unable to connect to server. Please contact your system administrator';
      } else {
        this.errorMessage = err.message;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/login/forms/login-form.component.ts